import React from 'react';
import '../App.css';

import {Navbar,Header_ICor,  FiltroIdeCort, IdeaCortaTod,Footer} from '../container';
import Modal_prue from '../components/modal/Modal' ;
// import  InputIcon  from '../components/inputIcon/InputIcon' ;

// import { Navbar, LB_Header_gri, LB_Texto,Recomendados_LB, Descarga_LB,  PuntosVenta_LB, NL_Descarga} from '../container';

const IdeaCorta =()=>{


  return (
    // <div className="SecIdeas">
     <div class="App_DB">

      <Navbar/>
      <Header_ICor/>
      {/* <InputIcon/> */}
       <FiltroIdeCort/>
     {/* <IdeaCortaTod/> */}
     <Footer/>
     <Modal_prue />
        
      
</div>
  )

}

export default IdeaCorta;
